import { FREE_TRIAL_APPLICATION_CREDITS } from './freeTrial';
import { lifeShackProductFacts } from './productFacts';

export const PASSIVE_APPLICATION_CREDITS = 15;
export const PROFESSIONAL_APPLICATION_CREDITS =
  lifeShackProductFacts.plans.professional.applicationCredits;
export const PREMIUM_APPLICATION_CREDITS = 100;
export const ULTIMATE_APPLICATION_CREDITS =
  lifeShackProductFacts.plans.ultimate.applicationCredits;
export const ELITE_APPLICATION_CREDITS =
  lifeShackProductFacts.plans.elite.applicationCredits;

export const AUTO_APPLY_PLAN_APPLICATION_CREDITS: Record<string, number> = {
  TRIAL: FREE_TRIAL_APPLICATION_CREDITS,
  PASSIVE: PASSIVE_APPLICATION_CREDITS,
  BASIC: PROFESSIONAL_APPLICATION_CREDITS,
  PROFESSIONAL: PROFESSIONAL_APPLICATION_CREDITS,
  PROFESSIONAL_QUARTERLY: PROFESSIONAL_APPLICATION_CREDITS,
  PREMIUM: PREMIUM_APPLICATION_CREDITS,
  ULTIMATE: ULTIMATE_APPLICATION_CREDITS,
  ULTIMATE_QUARTERLY: ULTIMATE_APPLICATION_CREDITS,
  ELITE: ELITE_APPLICATION_CREDITS,
  ELITE_QUARTERLY: ELITE_APPLICATION_CREDITS,
};

export function getAutoApplyPlanApplicationCredits(plan?: string | null) {
  if (!plan) return 0;
  return AUTO_APPLY_PLAN_APPLICATION_CREDITS[plan] ?? 0;
}
